import { c as _c } from "react/compiler-runtime";
import { getStringAsNumberOrZero } from "@/helpers/Helpers";
import type { RefObject } from "react";
const DEFAULT_INPUT_CLASS_NAME = "tw-appearance-none -tw-ml-0.5 tw-block tw-w-full tw-rounded-l-none tw-rounded-r-lg tw-border-0 tw-py-3 tw-px-3 tw-bg-iron-900 focus:tw-bg-iron-950 tw-text-white tw-font-medium tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 hover:tw-ring-iron-600 placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-text-sm tw-transition tw-duration-300 tw-ease-out";
const DEFAULT_SPAN_CLASS_NAME = "tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-iron-900 tw-rounded-l-lg tw-border tw-border-solid tw-border-iron-700 tw-px-3";
const getValueStr = (val: string): string => {
  if (val.length > 1 && val.startsWith("0")) {
    return val.slice(1);
  }
  return val;
};
export default function UserPageRateInput(t0) {
  const $ = _c(22);
  const {
    value,
    onChange,
    minMax,
    isProxy,
    inputRef,
    inputClassName: t1,
    spanClassName: t2,
    inputId,
    focusRingClassName,
    required: t3
  } = t0;
  const inputClassName = t1 === undefined ? DEFAULT_INPUT_CLASS_NAME : t1;
  const spanClassName = t2 === undefined ? DEFAULT_SPAN_CLASS_NAME : t2;
  const required = t3 === undefined ? false : t3;
  const valueAsNumber = getStringAsNumberOrZero(value);
  const isValidValue = isProxy || valueAsNumber >= minMax.min && valueAsNumber <= minMax.max;
  let t4;
  if ($[0] !== onChange) {
    t4 = event => {
      const inputValue = event.currentTarget.value;
      const strVal = ["-0", "0-"].includes(inputValue) ? "-" : inputValue;
      if (/^-?\d*$/.test(strVal)) {
        onChange(getValueStr(strVal));
      }
    };
    $[0] = onChange;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const handleChange = t4;
  let t5;
  if ($[2] !== isProxy || $[3] !== minMax || $[4] !== onChange || $[5] !== value) {
    t5 = () => {
      if (isProxy) {
        return;
      }
      const {
        min,
        max
      } = minMax;
      const valueAsNumber_0 = getStringAsNumberOrZero(value);
      if (valueAsNumber_0 > max) {
        onChange(`${max}`);
        return;
      }
      if (valueAsNumber_0 < min) {
        onChange(`${min}`);
      }
    };
    $[2] = isProxy;
    $[3] = minMax;
    $[4] = onChange;
    $[5] = value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const handleBlur = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="tw-w-3.5 tw-h-3.5 tw-flex-shrink-0 tw-text-iron-500" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <svg className="tw-w-3.5 tw-h-3.5 tw-flex-shrink-0 tw-text-iron-500" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== spanClassName) {
    t8 = <span className={spanClassName}>{t6}{t7}</span>;
    $[9] = spanClassName;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = `${focusRingClassName ?? (isValidValue ? "focus:tw-ring-primary-400" : "focus:tw-ring-red")} ${inputClassName}`;
  let t10;
  if ($[11] !== handleBlur || $[12] !== handleChange || $[13] !== inputId || $[14] !== inputRef || $[15] !== required || $[16] !== t9 || $[17] !== value) {
    t10 = <input ref={inputRef} type="text" id={inputId} autoComplete="off" required={required} value={value} onChange={handleChange} onBlur={handleBlur} className={t9} />;
    $[11] = handleBlur;
    $[12] = handleChange;
    $[13] = inputId;
    $[14] = inputRef;
    $[15] = required;
    $[16] = t9;
    $[17] = value;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t8) {
    t11 = <>{t8}{t10}</>;
    $[19] = t10;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}